export default function Form() {
  return {
    marginLG: 32
  }
}
